export const SVG_WIDTH = 944;
export const SVG_HEIGHT = 200;